import React, { useEffect, useState } from 'react';
import { Button, Card, Divider, Input, Spin, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

const NotesModal = (props) => {

    const dispatch = useDispatch();

    const { handleClose, handleSave, viewOnly = false } = props;
    const loadingDetails = useSelector(state => state.warehouseProd.loadingDetails);
    const rdxCurrentEditRow = useSelector(state => state.warehouseProd.currentEditRow); // stored for reset
    //console.log(rdxCurrentEditRow)
    const [editRow, setEditRow] = useState(rdxCurrentEditRow); // local component edits
    //console.log(editRow)

    useEffect(() => {
        console.log('[NotesModal] currentEditRow change');
        setEditRow(rdxCurrentEditRow);
    }, [
        dispatch,
        rdxCurrentEditRow,
    ]);

    const handleChangeOrderNotes = (e) => {
        console.log('handleChangeOrderNotes', e.target.value)
        setEditRow({
            ...editRow,
            orderNotes: e.target.value
        })
    }

    const handleChangeInternalNotes = (e) => {
        console.log('handleChangeInternalNotes', e.target.value)
        setEditRow({
            ...editRow,
            internalNotes: e.target.value
        })
    }

    const _handleSave = () => {
        // in case we need to do something in the component while saving
        handleSave(editRow);
    }

    const _handleClose = () => {
        // clear local edits and call props handleClose
        setEditRow({
            ...rdxCurrentEditRow
        })
        handleClose();
    }

    const handleResetNotes = () => {
        console.log('handleResetNotes')
        setEditRow({
            ...rdxCurrentEditRow
        })
    }

    if (!rdxCurrentEditRow || !editRow) {
        return null;
    }

    return (
        <Card>

            <Typography.Title level={4}>Order Notes</Typography.Title>
            <Input.TextArea
                placeholder={editRow.orderNotes ?? 'enter new notes'}
                value={editRow.orderNotes}
                onChange={handleChangeOrderNotes}
            />
            <Typography.Title level={4}>Internal Notes</Typography.Title>

            <Input.TextArea
                placeholder={editRow.internalNotes ?? 'enter new notes'}
                value={editRow.internalNotes}
                onChange={handleChangeInternalNotes}
            />

            {!viewOnly &&
                <>
                    <Divider />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button onClick={() => handleSave(editRow)}>Save</Button>
                        <Button onClick={handleResetNotes}>Reset</Button>
                        <Button onClick={_handleClose}>Cancel</Button>
                    </div>
                </>
            }

            {viewOnly &&
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={_handleClose}>Close</Button>
                </div>
            }

            {!loadingDetails
                ? <div style={{ display: 'inline', height: 40, width: 40 }} />
                : <Spin spinning={true} />
            }
        </Card>
    )
}

export default NotesModal;